import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TaskItem from '../TaskItem';
import styles from './TaskSection.module.css';

const TaskSection = ({
  id,
  title,
  icon,
  color,
  tasks,
  count,
  isCollapsible = false,
  defaultCollapsed = false,
  onTaskClick,
  onTaskComplete,
}) => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  // Hide section if no tasks (except for completed section which shows count)
  if (tasks.length === 0 && !isCollapsible) {
    return null;
  }

  const toggleCollapse = () => {
    if (isCollapsible) {
      setIsCollapsed(!isCollapsed);
    }
  };

  return (
    <div className={`${styles.taskSection} ${isCollapsed ? styles.collapsed : ''}`} id={`${id}-section`}>
      {/* Section header for regular sections with tasks OR completed section */}
      {(tasks.length > 0 || isCollapsible) && (
        <div className={styles.sectionHeader}>
          <div className={styles.sectionInfo}>
            {icon && <span className={styles.sectionIcon} style={{ color }}>{icon}</span>}
            <span className={styles.sectionTitle} style={{ color }}>
              {title}
            </span>
            {isCollapsible && count !== undefined && (
              <span className={styles.sectionCount}>{count}</span>
            )}
          </div>
          {isCollapsible && (
            <button 
              className={styles.collapseToggle}
              onClick={toggleCollapse}
              aria-label={isCollapsed
                ? t('records.views.task.section.expand_aria', { title })
                : t('records.views.task.section.collapse_aria', { title })}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
          )}
        </div>
      )}

      {/* Task list */}
      {!isCollapsed && tasks.length > 0 && (
        <div className={styles.taskList}>
          {tasks.map((task) => (
            <TaskItem
              key={task.id}
              task={task}
              section={id}
              onTaskClick={() => onTaskClick(task)}
              onComplete={(isComplete) => onTaskComplete(task.id, isComplete)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TaskSection;
